const initOverlayer = () => {
	const overlay = document.querySelector("#overlayer");
	if (overlay) { 
		const overlayVideo = overlay.querySelector("video");

		/* OVERLAYER */
		if (window.location.hash == "#popup") {
			overlay.style.display = "flex";

			if (overlayVideo) {
				overlayVideo.play();
			}
		}
	}
	const overlayer_btn = document.querySelector("#overlayer_btn");

	if (overlayer_btn) { 
		overlayer_btn.addEventListener("click", (e) => {
			e.preventDefault();
			overlay.style.display = "flex";
	
			if (overlayVideo) {
				overlayVideo.play();
			}
	
			e.currentTarget.blur();
		});
	}

    const closeBtns = document.querySelectorAll("#overlayer .close_btn, #overlayer a");
	
    closeBtns.forEach(btn => { 
        btn.addEventListener("click", (e) => { 
            e.preventDefault();

            const attr = e.currentTarget.getAttribute("href");
            if (typeof attr !== typeof undefined && attr !== false && attr != "#") {	
                window.location.href = attr;
            } else {
                overlay.style.display = "none";
                
                if (overlayVideo) {
                    overlayVideo.pause();
                }
            }
            e.currentTarget.blur();
        });
    });
}

export default initOverlayer;